/**
 * Ticket service
 *
 */
app.factory('TicketService', ['$http', '$q', function($http, $q) {
    return {

        /**
         * Get a ticket
         *
         * @param number: The ticket auth number
         * @param key: The ticket auth key
         * @param callback: Callback function which will be called
         *                  with the error (if any) and the ticket (if no error).
         */
        get_ticket: function(number, key, callback, advance_ticket_number) {
            var url = '/tickets/auth';
            if (advance_ticket_number) {
                url += '/advance_ticket_number/' + encodeURIComponent(advance_ticket_number);
            } else {
                url += '/number/' + number;
                url += '/key/' + key;
            }
            $http({
                method: 'GET',
                url: url,
                skipSessionLogout: true
            }).success(function(rsp, status) {
                return callback && callback(/*err*/null, rsp);
            }).error(function(rsp, status, headers, config) {
                return callback && callback(rsp);
            });
        },

        /**
         * Get a ticket from its scanned uri
         *
         * @param uri: The ticket uri
         * @param callback: Callback function which will be called
         *                  with the error (if any) and the ticket (if no error).
         */
        get_ticket_from_uri: function(uri, callback) {
            var url = PosConfig.engine_uri;
            url += '/fastapi/tickets/from_uri?uri=';
            url += encodeURIComponent(uri);

            $http({
                method: 'GET',
                url: url,
                skipSessionLogout: true,
                headers: {
                    'X-API-Key': PosConfig.api_key
                }
            }).success(function(rsp, status) {
                return callback && callback(/*err*/null, rsp);
            }).error(function(rsp, status, headers, config) {
                return callback && callback(rsp || true, /*ticket*/null);
            });
        },

        /**
         * Load the wallet, contact and bookings infos
         *
         * @param ticket_id: The ticket UUID (optional). If not provided, the current ticket is used.
         * @param callback: Callback function which will be called
         *                  with the error (if any) and the updated ticket (if no error).
         */
        load_ticket_infos: function(ticket_id, callback) {
            var url = '/ticket/view_json';
            var self = this;
            if (ticket_id)
                url += '/uuid/' + ticket_id;
            if (PosConfig.lang) {
                url += '?lang=' + PosConfig.lang;
            }
            if (PosConfig.context) {
                url += PosConfig.lang ? '&' + PosConfig.context : '?' + PosConfig.context; // FIXME hackish
            }
            var httpRequest = $http({
                method: 'POST',
                url: url,
                skipSessionLogout: true
            }).success(function(rsp, status) {
                rsp = self.update_ticket_from_rsp(rsp);
                callback && callback(null, rsp);
            }).error(function(rsp, status, headers, config) {
                callback && callback(rsp);
            });
        },

        update_ticket_from_rsp: function (rsp) {
            // XXX: remove this ticket_data insanity
            rsp.ticket_data                   = {};
            rsp.ticket_data.activated_at      = rsp.activated_at;
            rsp.ticket_data.activated_pricing = rsp.activated_pricing;
            rsp.ticket_data.contact           = rsp.contact;
            rsp.ticket_data.bookings          = rsp.bookings;
            rsp.ticket_data.windows           = rsp.windows;
            rsp.ticket_data.articles          = rsp.articles || [];
            rsp.articles                      = rsp.articles || [];
            rsp.available_bookings            = this.available_bookings(rsp.ticket_data);
            return rsp;
        },

        /**
         * Book on the current ticket
         *
         * @param string screening_id: The screening _id
         * @param string seat: The seat to book, optional
         * @param boolean overbook: True to overbook, false otherwise
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        book: function (screening_id, seat, overbook, callback) {
            var headers = {'Content-Type': 'application/x-www-form-urlencoded'};

            var url  = '/screening/book_on_ticket/' + screening_id;
                url += '?format=json&';
                url += 'overbook=' + (overbook ? 'true' : 'false');
            if (seat) {
                url += '&seat=' + seat;
            }
            if (PosConfig.session_id) {
                url += '&PHPSESSID=' + PosConfig.session_id;
            }
            if (PosConfig.lang) {
                url += '&lang=' + PosConfig.lang;
            }

            $http({'method': 'POST', 'url': url, 'headers': headers})
            .success(function(rsp, status, headers, config) {
                callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
                callback && callback(rsp.flash ? rsp.flash.error : null);
            });
        },

        /**
         * Unbook on the current ticket
         *
         * @param ticket_id: The ticket UUID (optional). If not provided, the current ticket is used.
         * @param string booking_id: The booking _id
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        unbook: function (ticket_id, booking_id, callback) {
            var headers = {'Content-Type': 'application/x-www-form-urlencoded'};
            var url = '/ticket/cancel_booking_json/' + booking_id;
            url += '?format=json';
            if (ticket_id)
                url += '&uuid=' + ticket_id;
            if (PosConfig.session_id) {
                url += '&PHPSESSID=' + PosConfig.session_id;
            }
            if (PosConfig.lang) {
                url += '&lang=' + PosConfig.lang;
            }

            $http({'method': 'POST', 'url': url, 'headers': headers})
            .success(function(rsp, status, headers, config) {
                  callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
              callback && callback(rsp.flash ? rsp.flash.error : ["Couldn't unbook"]);
            });
        },

        /**
         * Unset the current ticket
         *
         * @param function callback: Callback which receives the errors
         *                           (if any) and the server response (on success).
         */
        disable_book_mode: function (callback) {
            var headers = {'Content-Type': 'application/x-www-form-urlencoded'};
            var url = '/ticket/disable_book_mode_json?format=json';

            if (PosConfig.session_id) {
                url += '&PHPSESSID=' + PosConfig.session_id;
            }

            $http({'method': 'GET', 'url': url, 'headers': headers})
            .success(function(rsp, status, headers, config) {
                  callback && callback(null, rsp);
            })
            .error(function(rsp, status, headers, config) {
              callback && callback(rsp.flash ? rsp.flash.error : ["Couldn't unset the current ticket"]);
            });
        },

        /**
         * Return an object with the available and total number of
         * bookings for the provided ticket.
         *
         * @param {Ticket} ticket
         * @return {Object}
         */
        available_bookings: function (ticket) {
            let total     = 0;
            let available = 0;
            var reduced   = this.windows_reduce(ticket, /*filter_expired*/true);

            (ticket.windows || []).forEach(function (window) {
                total += window.nbookings;
            });

            reduced.forEach(function (window) {
                available += window.nbookings;
            });

            return { 'available' :  available, 'total' : total };
        },

        /**
         * Return the ticket windows with some more infos:
         *  - screening_ids
         *  - computed nbookings
         *  - booked_frames
         *
         * @param {Ticket} ticket
         * @param {Bool} filter_expired
         * @return array
         */
        windows_reduce: function (ticket, filter_expired) {
            let day = null;

            var reduced = _.map(ticket.windows, function (win) {
                var cpy = _.clone(win);
                // keep track of which screening are booked in this window
                cpy.screening_ids = [];
                return cpy;
            });

            (ticket.bookings || []).forEach(function (booking) {
                reduced[booking.window].screening_ids.push(booking.screening_id);
                reduced[booking.window].nbookings -= 1;
                if ('overlap' in reduced[booking.window] && !booking.ignore_overlap_rules) {
                    if (!reduced[booking.window].booked_frames) {
                        reduced[booking.window].booked_frames = [];
                    }
                    reduced[booking.window].booked_frames.push({
                        start_at: moment(booking.screening_start_at),
                        stop_at: moment(booking.screening_stop_at)
                    });
                }
                // for same_day flag a day must be defined
                if(!day && !_.isUndefined(reduced[booking.window].same_day) && reduced[booking.window].same_day)
                    day = moment(booking.screening_start_at).format("YYYY-MM-DD");
            });

            if (day) {
                // add to all windows with the same_day flag, the day field
                reduced.filter(function (win) {
                    return win.same_day;
                }).forEach(function (win) {
                    win.day = day;
                });
            }

            if (!filter_expired)
                return reduced;

            // filter on running and future windows
            return reduced.filter(function (win) {
                return (!('stop_at' in win) || (moment(win.stop_at).isAfter(moment())));
            });
        },

        /**
         * Check if the provided ticket has a matching window for the screening.
         *
         * @param ticket
         * @param screening
         * @param callback (optional): Callback function which receives true
         *                  if the ticket has a matching window, false otherwise.
         *
         * @return boolean if no callback provided
         */
        windows_match: function (ticket, screening, callback) {
            function overlaps(screening_start_at, screening_stop_at, overlap, booked_frames) {
                screening_start_at = moment(screening_start_at).add(moment.duration(overlap));
                screening_stop_at  = moment(screening_stop_at).subtract(moment.duration(overlap));

                return booked_frames.reduce((result, booked_frame) => {
                    return result || (
                        screening_start_at < booked_frame.stop_at &&
                        screening_stop_at > booked_frame.start_at
                    );
                }, false);
            }

            var reduced = this.windows_reduce(ticket);

            for (var i = 0; i < reduced.length; i++) {
                var win = reduced[i];
                if (win.nbookings === 0)
                    continue;
                // overlap case, only if we are not booking the same screening
                if (!_.isUndefined(win.booked_frames) && !(win.screening_ids || []).includes(screening._id))
                    if (!screening.ignore_overlap_rules && overlaps(screening.start_at, screening.stop_at, win.overlap, win.booked_frames)){
                        continue;
                    }
                if (_.filter(win.screening_ids, function (id) {
                    return id === screening._id;
                }).length >= (win.nsame_screening || 1))
                    continue;
                if (!_.isUndefined(win.day)) {
                    if (win.day === moment(screening.start_at).format("YYYY-MM-DD")) {
                        return callback ? callback(true) : true;
                    }
                    continue;
                }
                else if (win.screening_id && win.screening_id === screening._id){
                    return callback ? callback(true) : true;
                }
                else if (win.start_at <= screening.start_at && screening.start_at < win.stop_at) {
                    return callback ? callback(true) : true;
                }
            }

            return callback ? callback(false) : false;
        }
    };
}]);
